import React from 'react';
import { Tabs } from './tabs';

const tabbedPanelItems = [
  {
    id: '1',
    title: 'Item 1 Title',
    children: <div>Table will go here (Test #1)</div>,
  },
  {
    id: '2',
    title: 'Item 2 Longer Title',
    children: <div>Table will go here (Test #2)</div>,
  },
  {
    id: '3',
    title: 'Item 3',
    children: <div>Table will go here (Test #3)</div>,
  },
];

export const Demo1 = () => {
  return <Tabs items={tabbedPanelItems} />;
};
